import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import * as MUI from "./component";
export const AppPolycaikTheme = responsiveFontSizes(
  createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: "#ffca07",
      },
      secondary: {
        main: "#f5f4ef",
      },
      background: {
        default: "#353535",
        paper: "#3F3F3F",
        group: "#303030",
      },
      error: {
        main: "#e53935",
      },
    },
    typography: {
      fontFamily: `"Lato-Bold"`,
      subtitle2: {
        fontSize: "1rem", // Changes it from 14px to 16px
      },
    },
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
      MuiButtonGroup: {
        defaultProps: {
          size: "small",
        },
      },
      MuiCheckbox: {
        defaultProps: {
          size: "small",
        },
      },
      MuiFab: {
        defaultProps: {
          size: "small",
        },
      },
      MuiFormControl: {
        defaultProps: {
          margin: "dense",
          size: "small",
        },
      },
      MuiFormHelperText: {
        defaultProps: {
          margin: "dense",
        },
      },
      MuiIconButton: {
        defaultProps: {
          size: "small",
        },
      },
      MuiInputBase: {
        defaultProps: {
          margin: "dense",
        },
      },
      MuiInputLabel: {
        defaultProps: {
          margin: "dense",
        },
      },
      MuiSwitch: {
        defaultProps: {
          size: "small",
        },
      },
      MuiTextField: {
        defaultProps: {
          margin: "dense",
          size: "small",
        },
      },
      ...MUI.MuiToolBar,
      ...MUI.MuiAppBar,
      ...MUI.MuiPaper,
      ...MUI.MuiRadio,
      ...MUI.MuiGrid,
      ...MUI.MuiTabs,
      ...MUI.MuiTab,
      ...MUI.MuiCard,
      ...MUI.MuiButton,
    },
  }),
);
